import React from 'react';
export function FooterSection() {
  return <footer className="bg-slate-900 text-slate-300 py-16" data-id="element-70">
      <div className="container mx-auto px-4 text-center" data-id="element-71">
        <div className="text-pink-400 font-bold tracking-[0.2em] text-sm uppercase mb-4" data-id="element-72">
          🌸 Aula Mater
        </div>
        <p className="text-slate-400 max-w-md mx-auto mb-8" data-id="element-73">
          Herramientas profesionales y recursos prácticos para fortalecer la
          práctica clínica psicopedagógica.
        </p>
        <div className="border-t border-slate-800 pt-6 text-xs text-slate-500" data-id="element-74">
          © 2026 Aula Mater — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}